module.exports = __webpack_public_path__ + "static/quiz4_question9-595d0724b5d37ed0381f2175fb2bacfe.jpg";